import { render, staticRenderFns } from "./ProductSinglePublic.vue?vue&type=template&id=66ce8eee&scoped=true&lang=pug"
import script from "./ProductSinglePublic.vue?vue&type=script&lang=js"
export * from "./ProductSinglePublic.vue?vue&type=script&lang=js"
import style0 from "./ProductSinglePublic.vue?vue&type=style&index=0&id=66ce8eee&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66ce8eee",
  null
  
)

export default component.exports